import { memo } from "react";
import { Text, View, Page, Document, PDFViewer } from '@react-pdf/renderer';
import styles from "../pdf/Styles.js";
import "../pdf/Fonts.js";

const MonthlyMilkProductionPdf = ({ selectedOwner, milkData, selectedYear, selectedMonth }) => {
    const renderMilkDataTable = () => {
        if (!milkData || milkData.length === 0) {
            return (
                <View style={styles.sisterCategory}>
                    <Text style={styles.subheading}>Δεδομένα Γαλακτοπαραγωγής:</Text>
                    <Text style={styles.sisterCell}>Δεν υπάρχουν διαθέσιμα δεδομένα γαλακτοπαραγωγής για τα ζώα αυτής της μονάδας</Text>
                </View>
            );
        }

        // Sort the milkData array by registrationCode in ascending order
        const sortedMilkData = [...milkData].sort((a, b) => {
            // Handling numeric registration codes
            if (!isNaN(a.registrationCode) && !isNaN(b.registrationCode)) {
                return Number(a.registrationCode) - Number(b.registrationCode);
            }
            // Handling alphanumeric registration codes
            return String(a.registrationCode).localeCompare(String(b.registrationCode));
        });

        return (
            <View style={styles.sisterCategory}>
                <View style={styles.sisterTable}>
                    <View style={styles.sisterTableHeader}>
                        <Text style={styles.sisterCell}>Α/Α</Text>
                        <Text style={styles.sisterCell}>Κωδικός Ζώου</Text>
                        <Text style={styles.sisterCell}>Α/Α Ελέγχου</Text>
                        <Text style={styles.sisterCell}>Ημερομηνία Τοκετού</Text>
                        <Text style={styles.sisterCell}>Πρωί - Γάλα (γρ)</Text>
                        <Text style={styles.sisterCell}>Μεσημέρι - Γάλα (γρ)</Text>
                        <Text style={styles.sisterCell}>Βράδυ - Γάλα (γρ)</Text>
                        <Text style={styles.sisterCell}>Λίπος (%)</Text>
                        <Text style={styles.sisterCell}>Πρωτεΐνη (%)</Text>
                        <Text style={styles.sisterCell}>Λακτόζη (%)</Text>
                        <Text style={styles.sisterCell}>Ημερομηνία Ελέγχου</Text>
                    </View>
                    {sortedMilkData.map((record, index) => {
                        const morningMilk = record.milkProduced.find(entry => entry.type === "Πρωί")?.milk || 0;
                        const noonMilk = record.milkProduced.find(entry => entry.type === "Μεσημέρι")?.milk || 0;
                        const eveningMilk = record.milkProduced.find(entry => entry.type === "Βράδυ")?.milk || 0;
                        const fat = record.fat !== null ? record.fat : "-";
                        const protein = record.protein !== null ? record.protein : "-";
                        const lactose = record.lactose !== null ? record.lactose : "-";
                        return (
                            <View key={index} style={styles.sisterRow}>
                                <Text style={styles.sisterCell}>{index + 1}</Text>
                                <Text style={styles.sisterCell}>{record.registrationCode}</Text>
                                <Text style={styles.sisterCell}>{record.milkRecordingCount}</Text>
                                <Text style={styles.sisterCell}>{new Date(record.lambingDate).toLocaleDateString("el-GR")}</Text>
                                <Text style={styles.sisterCell}>{morningMilk}</Text>
                                <Text style={styles.sisterCell}>{noonMilk}</Text>
                                <Text style={styles.sisterCell}>{eveningMilk}</Text>
                                <Text style={styles.sisterCell}>{fat}</Text>
                                <Text style={styles.sisterCell}>{protein}</Text>
                                <Text style={styles.sisterCell}>{lactose}</Text>
                                <Text style={styles.sisterCell}>{new Date(record.testDate).toLocaleDateString("el-GR")}</Text>
                            </View>
                        );
                    })}
                </View>
            </View>
        );
    };

    return (
        <>
            <PDFViewer style={{ width: '85vw', height: '100vh' }}>
                <Document>
                    <Page size='A3' style={styles.page} wrap>
                        <View style={styles.container}>
                            {/* Title Page */}
                            <View style={styles.header}>
                                <Text style={styles.title}>{`Δελτίο Μηνιαίας Γαλακτομέτρησης`}</Text>
                            </View>

                            {/* Owner Information */}
                            <View style={styles.familyBox}>
                                <Text>{`Μονάδα: ${selectedOwner?.lastName} ${selectedOwner?.firstName}`}</Text>
                                <Text>{`Κωδικός Μονάδας: ${selectedOwner?.code || "-"}`}</Text>  {/* Owner Code */}
                                <Text>{`Διεύθυνση: ${selectedOwner?.address || "-"}`}</Text>  {/* Owner Address */}
                                <Text>{`Νομός: ${selectedOwner?.county || "-"}`}</Text>  {/* Owner County */}
                                <Text>{`Μήνας Ελέγχου: ${selectedMonth} ${selectedYear}`}</Text>  {/* Owner County */}
                            </View>
                            {/* Milk Production Data */}
                            {renderMilkDataTable()}
                        </View>
                    </Page>
                </Document>
            </PDFViewer>
        </>
    );
};

export default memo(MonthlyMilkProductionPdf);
